export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-16 md:pt-[72px] bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 overflow-hidden opacity-[0.06] pointer-events-none">
        <div className="absolute top-10 left-[10%] text-[200px] md:text-[300px] font-heading text-primary-500 select-none">漫</div>
        <div className="absolute bottom-10 right-[5%] text-[160px] md:text-[260px] font-heading text-accent-500 select-none">画</div>
      </div>

      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 md:mb-5">
              下拉式漫画 · 竖屏滚动阅读
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4 md:mb-5">
              酷漫屋 · 下拉式漫画免费全集在线阅读
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-7">
              酷漫屋是一个专注于<strong className="text-foreground-800 font-semibold">竖屏滚动漫画</strong>的在线阅读平台。在这里你可以体验丝滑的<strong className="text-foreground-800 font-semibold">下拉式阅读</strong>方式，无需翻页——只需向下滑动就能畅享完整章节。平台持续收录<strong className="text-foreground-800 font-semibold">日漫、韩漫和国漫</strong>热门条漫作品，每日更新多部优质内容，从恋爱甜宠到热血冒险，从悬疑推理到奇幻异世界，各类题材一应俱全。当前全站已累计收录超过<strong className="text-foreground-800 font-semibold">8000+部</strong>漫画作品，周更新频次保持在<strong className="text-foreground-800 font-semibold">300话以上</strong>，无论你是碎片时间追更，还是周末沉浸式补番，酷漫屋都为漫画爱好者打造了最舒适的条漫阅读体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-5 mb-6 md:mb-7">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">8000+ 漫画作品</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">每日更新 300+ 话</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">全站免费阅读</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                开始阅读
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 border border-foreground-300 text-foreground-700 font-medium text-sm rounded-md hover:border-primary-300 hover:text-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                下载移动端
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20composition%20featuring%20colorful%20comic%20book%20panels%20and%20manga%20illustration%20elements%20floating%20against%20a%20soft%20cream%20background%20with%20subtle%20coral%20and%20amber%20gradient%20accents%2C%20modern%20digital%20reading%20aesthetic%2C%20Japanese%20manga%20and%20Korean%20webtoon%20style%20blend%2C%20cozy%20atmosphere%2C%20editorial%20design%2C%20high%20detail%2C%20harmonious%20composition%20with%20comfortable%20negative%20space&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="酷漫屋 - 下拉式漫画在线阅读，日漫韩漫国漫免费看"
                className="w-full h-full object-cover object-top rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}